<ng-template #titleContent>
    <ng-content></ng-content>
</ng-template>

<div>
    @switch (headerLevelShopTitle) {
        @case (1) {
            <h1 [class.sr-only]="isScreenReaderOnly" [attr.tabIndex]="isScreenReaderOnly ? -1 : undefined">
                <ng-container *ngTemplateOutlet="titleContent"></ng-container>
            </h1>
        }
        @case (2) {
            <h2 [class.sr-only]="isScreenReaderOnly" [attr.tabIndex]="isScreenReaderOnly ? -1 : undefined">
                <ng-container *ngTemplateOutlet="titleContent"></ng-container>
            </h2>
        }
        @case (3) {
            <h3 [class.sr-only]="isScreenReaderOnly" [attr.tabIndex]="isScreenReaderOnly ? -1 : undefined">
                <ng-container *ngTemplateOutlet="titleContent"></ng-container>
            </h3>
        }
        @case (4) {
            <h4 [class.sr-only]="isScreenReaderOnly" [attr.tabIndex]="isScreenReaderOnly ? -1 : undefined">
                <ng-container *ngTemplateOutlet="titleContent"></ng-container>
            </h4>
        }
        @case (5) {
            <h5 [class.sr-only]="isScreenReaderOnly" [attr.tabIndex]="isScreenReaderOnly ? -1 : undefined">
                <ng-container *ngTemplateOutlet="titleContent"></ng-container>
            </h5>
        }
        @default {
            <p [class.sr-only]="isScreenReaderOnly" [attr.tabIndex]="isScreenReaderOnly ? -1 : undefined">
                <ng-container *ngTemplateOutlet="titleContent"></ng-container>
            </p>
        }
    }
</div>
